import styled from 'styled-components';

export const StyledModalHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    margin-top: -1px;
    width: 100%;
`;
